import ReactSlider from 'react-slider';
import { Header, Segment } from 'semantic-ui-react';
import { SUPPORTED_YEARS } from '../../../constnats/generalConstants';
import AdvancedSettingsToggle from '../../buttons/advancedSettingsToggle';
import ToggleGroup from '../../toggleGroup';
import { ConfigProps, KeyValueOptions } from './constants';
import { CheckboxBtn, MultiselectField, SelectFieldWrapper } from './fields';
import './styles.css';

const currentYear = new Date().getFullYear();

function FilterAndSortCfgV2({ config, onChange, granularPeriodsFiltering, advancedConfig, onAdvancedChange }) {
    const onPropChange = (prop, val) => {
        onChange(Object.assign({}, config, { [prop]: val }));
    };

    const onTableConfigPropChange = (prop, val) => {
        onAdvancedChange(Object.assign({}, advancedConfig, { [prop]: val }));
    };

    return (
        <Segment className="tableConfigSegment baseSettings" size="mini">
            <div className="base-settings-wrapper flex-container">
                <div className="flex-container--item min-w-100 years-filter">
                    <YearsFilter
                        config={config[ConfigProps.YEARS_FILTER]}
                        onChange={(val) => onPropChange(ConfigProps.YEARS_FILTER, val)}
                    />
                </div>

                <div className="flex-container--item periods-filter">
                    <PeriodFilter
                        config={config[ConfigProps.PERIODS_FILTER]}
                        onChange={(val) => onPropChange(ConfigProps.PERIODS_FILTER, val)}
                        {...{ granularPeriodsFiltering }}
                    />
                </div>

                <div className="flex-container--item report-types-filter">
                    <ReportTypeFilter
                        config={config[ConfigProps.REPORT_TYPES_FILTER]}
                        onChange={(val) => onPropChange(ConfigProps.REPORT_TYPES_FILTER, val)}
                    />
                </div>

                <div className="flex-container--item">
                    <FillingTypeFilter
                        config={config[ConfigProps.FILLING_TYPE_FILTER]}
                        onChange={(val) => onPropChange(ConfigProps.FILLING_TYPE_FILTER, val)}
                    />
                </div>

                <div className="flex-container--item">
                    <ConditionalFilteringFilter
                        config={config}
                        onChange={(p, val) => {
                            onPropChange(ConfigProps.ORIGINAL_VERSION_CONDITIONAL_FILTER, val);
                        }}
                    />
                </div>

                <div className="flex-container--item">
                    <Scale
                        config={config}
                        onPropChange={(p, val) => {
                            onPropChange(ConfigProps.PREFFERED_SCALE, val);
                        }}
                    />
                </div>

                <div className="flex-container--item order">
                    <Order
                        config={config}
                        onPropChange={(p, val) => {
                            onPropChange(ConfigProps.REPORTS_ORDER, val);
                        }}
                    />
                </div>

                <div className='flex-container--item'>
                    <Notes config={advancedConfig} onPropChange={onTableConfigPropChange}/>
                </div>

                <div className="flex-container--item">
                    <Growth
                        config={config}
                        onPropChange={(p, val) => {
                            onPropChange(p, val);
                        }}
                    />
                </div>
            </div>
            <AdvancedSettingsToggle
                showAdvancedSettings={config[ConfigProps.SHOW_ADVANCED_SETTINGS]}
                toggleAdvancedSettings={() =>
                    onPropChange(ConfigProps.SHOW_ADVANCED_SETTINGS, !config[ConfigProps.SHOW_ADVANCED_SETTINGS])
                }
            />
        </Segment>
    );
}

function Notes({ config, onPropChange }) {
    return (
        <div className="config-module">
            <ModuleHeader text="Notes" />
            <ToggleGroup
                activeValue={!!config[ConfigProps.SHOW_NOTES]}
                onChange={(value) => onPropChange(ConfigProps.SHOW_NOTES, value)}
            >
                <ToggleGroup.Button value={true}>Show</ToggleGroup.Button>
                <ToggleGroup.Button value={false}>Hide</ToggleGroup.Button>
            </ToggleGroup>
        </div>
    );
}

function Growth({ config, onPropChange }) {
    const checkbox = (prop, label) => (
        <CheckboxBtn label={label} checked={config[prop]} onChange={(data) => onPropChange(prop, data)} />
    );
    return (
        <div className="configModule">
            <ModuleHeader text="Growth" />
            <div className="configModule-body">
                {checkbox(ConfigProps.SHOW_YEARLY_GROWTH_PERCENTAGES, 'YoY')}
                {checkbox(ConfigProps.SHOW_PERIOD_GROWTH_PERCENTAGES, 'PoP')}
            </div>
        </div>
    );
}

function Scale({ config, onPropChange }) {
    return (
        <div className="configModule">
            <ModuleHeader text="Scale" />
            <ToggleGroup
                activeValue={String(config[ConfigProps.PREFFERED_SCALE])}
                onChange={(newValue) => onPropChange(ConfigProps.PREFFERED_SCALE, Number(newValue))}
            >
                {KeyValueOptions.SCALE_OPS.map((option) => (
                    <ToggleGroup.Button key={String(option.key)} value={String(option.key)}>
                        {option.key ? option.value[0] : option.value}
                    </ToggleGroup.Button>
                ))}
            </ToggleGroup>
        </div>
    );
}
function Order({ config, onPropChange }) {
    return (
        <div className="configModule">
            <ModuleHeader text="Order" />
            <ToggleGroup
                activeValue={config[ConfigProps.REPORTS_ORDER]}
                onChange={(val) => onPropChange(ConfigProps.REPORTS_ORDER, val)}
            >
                {KeyValueOptions.SORTING.map((option) => (
                    <ToggleGroup.Button key={option.key} value={option.key}>
                        {option.value}
                    </ToggleGroup.Button>
                ))}
            </ToggleGroup>
        </div>
    );
}

function PeriodFilter({ config, onChange, granularPeriodsFiltering }) {
    return (
        <div className="configModule">
            <ModuleHeader text="Periods" />
            <div className="configModule-body">
                <MultiselectField
                    selected={config}
                    optionsKV={
                        granularPeriodsFiltering
                            ? KeyValueOptions.GRANULAR_PERIODS_FILTER_OPS
                            : KeyValueOptions.PERIODS_FILTER_OPS
                    }
                    onChange={(x) => onChange(x)}
                />
            </div>
        </div>
    );
}

function ReportTypeFilter({ config, onChange }) {
    return (
        <div className="configModule">
            <ModuleHeader text="Formats" />
            <div className="configModule-body">
                <MultiselectField
                    selected={config}
                    optionsKV={KeyValueOptions.REPORT_TYPE_FILTER}
                    onChange={onChange}
                />
            </div>
        </div>
    );
}

function FillingTypeFilter({ config, onChange }) {
    return (
        <div className="configModule">
            <ModuleHeader text="Versions" />
            <div className="configModule-body">
                <MultiselectField
                    selected={config}
                    optionsKV={KeyValueOptions.FILLING_TYPE_FILTER}
                    onChange={onChange}
                />
            </div>
        </div>
    );
}

function ConditionalFilteringFilter({ config, onChange }) {
    return (
        <div className="configModule">
            <ModuleHeader text="Hide Original if" />
            <SelectFieldWrapper
                className="max-w-120 margin-l-r-auto"
                label=""
                config={config}
                prop={ConfigProps.ORIGINAL_VERSION_CONDITIONAL_FILTER}
                opsKV={KeyValueOptions.ORIGINAL_VERSION_CONDITIONAL_FILTER}
                onChange={onChange}
            />
        </div>
    );
}

function YearsFilter({ config, onChange }) {
    return (
        <div className="configModule">
            <ModuleHeader text="Years" />
            <ReactSlider
                className="horizontal-slider"
                thumbClassName="slider-thumb"
                trackClassName="slider-track"
                defaultValue={[Number(SUPPORTED_YEARS[0]), currentYear + 1]}
                renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                pearling
                value={[config.from, config.to]}
                minDistance={0}
                min={Number(SUPPORTED_YEARS[0])}
                max={currentYear + 1}
                onAfterChange={(s) => onChange({ from: s[0], to: s[1] })}
            />
        </div>
    );
}

function ModuleHeader({ text }) {
    return (
        <Header as="h5" textAlign="center">
            {text}
        </Header>
    );
}

export default FilterAndSortCfgV2;
